<template>
  <div>
    <div id="mediamap"></div>
    <!-- 地图top10城市 -->
    <div
      style="display: inline-block; width: 360px; height: 300px"
      id="mapBiaogeDom"
    >
      <table>
        <thead>
          <tr style="background-color: #f1ae74; color: #ffffff">
            <th align="center">序号</th>
            <th
              align="center"
              style="width: 100px"
              class="maplistAre"
            >
              地区
            </th>
            <th
              align="center"
              style="width: 200px"
              class="maplistnum"
            >
              数量
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            style="
                      background-color: #fdfbf5;
                      border-bottom: dashed 1px #dbdbdb;
                    "
            v-for="(item, i) in html"
            :key="i"
          >
            <td
              align="center"
              style="background-color: #f7efe5; color: #c77f40"
            >
              {{ i + 1 }}
            </td>
            <!--地区-->
            <td align="center">{{ item.name }}</td>
            <!--数量-->
            <td align="center">{{ item.value }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
export default {
  props: ["mapList"],
  data() {
    return {
      html: []
    };
  },
  methods: {
    getoptions(option) {
      var chartDom = document.getElementById("mediamap");
      var myChart = echarts.init(chartDom);
      option && myChart.setOption(option);
    }
  },
  watch: {
    mapList(newval) {
      if (newval) {
        if (newval.length > 0) {
          let mapArr = newval;
          let option = {
            title: {
              // text: 'iphone销量',
              // subtext: '纯属虚构',
              // left: 'center'
            },
            tooltip: {
              trigger: "item"
            },
            legend: {
              orient: "horizontal", //布局方向vertical(纵向)horizontal(横向)
              left: "left",
              // data:['抖音','快手'],
              selectedMode: "single" //空中图例单(single)/双(multiple)选状态
            },
            visualMap: {
              min: 0,
              max: mapArr[0].value + 100,
              left: "left",
              top: "bottom",
              text: ["高", "低"], // 文本，默认为数值文本
              calculable: true,
              show:false
            },
            toolbox: {
              show: true,
              orient: "horizontal",
              feature: {
                mark: { show: false },
                // dataView : {show: true, readOnly: false},
                restore: { show: true },
                saveAsImage: { show: true }
              }
            },
            series: [
              {
                name: "数量",
                type: "map",
                mapType: "china",
                roam: false,
                label: {
                  normal: {
                    show: false //显示省份名称
                  },
                  emphasis: {
                    show: false
                  }
                },
                showLegendSymbol: false, //隐藏描点
                itemStyle: {
                  show: false,
                  normal: {
                    show: false,
                    // areaColor:'green',
                    color: "#FF8500" //点的颜色设置ddb926
                    // size:10
                  }
                },
                data: mapArr
              }
            ]
          };

          setTimeout(() => {
            this.getoptions(option);
          }, 1000);

          this.html = mapArr.slice(0, 10);
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
#mediamap {
  width: 100%;
  height: 100%;
}
</style>